import { Action, createReducer, on } from '@ngrx/store';
import { decreaseLoading } from '../utils';
import * as UserActions from './users.actions';
import { LoggedInUser, UserState } from './users.models';

export let usersInitialState: UserState = {
    loading: 0,
    users: [],
    loggedInUser: undefined,
    totalUsers: 0,
    availableUsers: { entries: [], totalEntries: 0 },
};

export const userReducer = createReducer(
    usersInitialState,
    on(UserActions.loading, (state) => {
        return { ...state, loading: state.loading + 1 };
    }),
    on(UserActions.loadingDone, (state) => {
        return { ...state, loading: decreaseLoading(state.loading) };
    }),
    on(UserActions.loadedLoggedInUser, (state, { data }) => {
        return {
            ...state,
            loggedInUser: new LoggedInUser(data),
        };
    }),
    on(UserActions.updatedLoggedInUser, (state, { user }) => {
        return {
            ...state,
            loggedInUser: new LoggedInUser(user),
        };
    })

    /**
     * HINT for CREATING, UPDATING and DELETING users:
     * Reload users instead of updating state.users, because of server side pagination.
     * Updating state.users might lead to wrong display of data depending on filterParams
     */
);

export function users(state = usersInitialState, action: Action): UserState {
    return userReducer(state, action);
}
